import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

export const styles = (theme: Theme) => {
	return ({
		cardContent: {
			"&:hover .actions": {
				visibility: "visible"
			},
			"& .actions": {
				visibility: "hidden"
			}
		},
		greyCardContent: {
			"&:hover .actions": {
				visibility: "visible",
			},
			"& .actions": {
				visibility: "hidden"
			},
			opacity: .5,
		},
		agentLabel: {
			margin: 10,
		},
		position: {
			minWidth: 40,
		},
		positionItem: {
			display: "flex", 
			justifyContent: "flex-end", 
			flexGrow: 1,
		},
		deleteItem: {
			display: "flex", justifyContent: "flex-end"
		}
	} satisfies Record<string, CSSObject>)
};
